import { prayerRamadanAr } from './golf4App.ar.js';
// Arabisch (ar), weatherPrayer: zelfde vorm als weatherPrayer.nl.ts.
//
// NEUTRAAL (zoals nl): locatie (behalve de gebedsvarianten), het hele weer, de kioskvraag en de
// statusmeldingen per tablet noemen nooit gebed, moskee of de oproep. Weerwoorden gelijk aan
// kioskWeather.ar.ts. Gebedsnamen: bij "Arabische namen" in Arabisch schrift (الفجر، الظهر …);
// bij "Turkse namen" blijven de Turkse namen (Diyanet) staan. {call} is altijd "الأذان".
export const weatherPrayerAr = {
    geo: {
        title: 'الموقع',
        intro: 'اختاروا الرمز البريدي أو مدينتكم. نحفظ فقط منطقة بحجم كيلومتر تقريبًا.',
        searchLabel: 'الرمز البريدي أو المدينة',
        searchPlaceholder: 'مثلًا: 3511 AA أو Utrecht',
        searchButton: 'بحث',
        searchHint: 'لا حاجة إلى رقم البيت؛ ولا نرسله أيضًا.',
        noResults: 'لم نجد شيئًا. جرّب رمزًا بريديًا أو اسم مدينة.',
        tooMany: 'على مهلك: حاول مرة أخرى بعد دقيقة.',
        chosen: 'المنطقة: {label}',
        privacy: 'لا نحفظ الشارع ولا رقم البيت ولا المكان بالضبط. الأقارب المربوطون والضيوف وروابط الأجندة لا يرون هذا أبدًا.',
        remove: 'مسح الموقع',
        removed: 'تم مسح الموقع.',
        variants: {
            weather: {
                settingsBody: 'للطقس على اللوحة',
                why: 'لماذا؟ للطقس على اللوحة. لا لشيء آخر.',
                removeConfirm: 'سنمسح موقع عائلتكم وموقع الأجهزة اللوحية. سيتوقف الطقس حتى تختار موقعًا جديدًا. هل تتابع؟',
                askBody: 'مرة واحدة، من أجل الطقس. نحفظ فقط منطقة بحجم كيلومتر تقريبًا.',
            },
            prayer: {
                settingsBody: 'لمواقيت الصلاة',
                why: 'لماذا؟ لمواقيت الصلاة. لا لشيء آخر.',
                removeConfirm: 'سنمسح موقع عائلتكم وموقع الأجهزة اللوحية. ستتوقف مواقيت الصلاة حتى تختار موقعًا جديدًا. هل تتابع؟',
                askBody: 'مرة واحدة، من أجل الأوقات على اللوحة. نحفظ فقط منطقة بحجم كيلومتر تقريبًا.',
            },
            both: {
                settingsBody: 'للطقس ومواقيت الصلاة',
                why: 'لماذا؟ للطقس على اللوحة ولمواقيت الصلاة. لا لشيء آخر.',
                removeConfirm: 'سنمسح موقع عائلتكم وموقع الأجهزة اللوحية. سيتوقف الطقس ومواقيت الصلاة حتى تختار موقعًا جديدًا. هل تتابع؟',
                askBody: 'مرة واحدة، من أجل الطقس والأوقات على اللوحة. نحفظ فقط منطقة بحجم كيلومتر تقريبًا.',
            },
        },
        device: {
            title: 'موقع هذا الجهاز اللوحي',
            household: 'مثل العائلة',
            own: 'استخدم موقع هذا الجهاز',
            ownHint: 'مفيد إذا كان هذا الجهاز في مكان آخر، مثلًا في بيت العطلة.',
            otherHome: 'هل الجهاز في بيت شخص آخر؟ عندها نحفظ أيضًا منطقة بحجم كيلومتر تقريبًا من ذلك البيت. أخبر ذلك الشخص.',
            pending: 'سيظهر سؤال على الجهاز اللوحي. اضغط هناك على «نعم، حدّده مرة واحدة».',
            measured: 'منطقة هذا الجهاز: {label}',
            far: 'هذا الجهاز على بعد {km} كم تقريبًا من عنوان عائلتكم.',
            remeasure: 'حدّده من جديد',
            failed: 'لم يستطع الجهاز تحديد موقعه. نستخدم موقع العائلة.',
        },
        kiosk: {
            askTitle: 'هل يمكن لهذا الجهاز استخدام موقعه؟',
            yes: 'نعم، حدّده مرة واحدة',
            no: 'لا',
            busy: 'لحظة، جارٍ البحث…',
            done: 'تم: {label}',
            failed: 'لم ينجح ذلك. نستخدم موقع العائلة.',
        },
        web: {
            choose: 'اختيار الموقع',
            change: 'تغيير الموقع',
            none: 'لم يُختر موقع بعد.',
            area: 'المنطقة: {label}',
            tablets: 'الأجهزة اللوحية',
            tabletsNone: 'لا أجهزة لوحية مربوطة بعد.',
            edit: 'تغيير',
            save: 'حفظ',
            saved: 'تم الحفظ',
            cancel: 'إلغاء',
            country: 'البلد',
            countryNl: 'هولندا',
            countryOther: 'بلد آخر',
            city: 'المدينة',
            postcode: 'الرمز البريدي',
            countryCode: 'رمز البلد (مثلًا BE أو DE)',
            searching: 'جارٍ البحث…',
            pick: 'اختر منطقتك',
            removeTitle: 'مسح الموقع؟',
            unavailable: 'البحث لا يعمل الآن. حاول لاحقًا.',
            requested: 'طُلب التحديد',
            deviceSame: 'مثل العائلة',
            deviceSameWith: 'مثل العائلة ({label})',
        },
        credits: {
            pdok: 'بيانات الموقع: PDOK/Kadaster',
            osm: '© المساهمون في OpenStreetMap (ODbL)',
        },
    },
    weather: {
        title: 'الطقس',
        settingsBody: 'جاكيت أو جزمة أو كريم الشمس؟ نصيحة للأوقات التي يخرج فيها الأطفال من البيت',
        enabled: 'عرض الطقس',
        needsLocation: 'اختر موقعًا أولًا، ثم نعرض الطقس.',
        showInBanners: 'في تنبيه الخروج («الساعة 8:15 إلى المدرسة: معطف مطر وجزمة»)',
        adjust: 'تعديل',
        morning: 'الصباح من {start} إلى {end}',
        thresholdsTitle: 'متى أي نصيحة',
        thresholdsNote: 'الشمس والحر والرياح والانزلاق تتبع RIVM وKNMI. حدود المعاطف والكنزات هي معيارنا الخاص: عدّلها كما تشاء.',
        thresholds: {
            sweaterBelowC: 'سترة أو كنزة تحت {value} °C (الإحساس)',
            coatBelowC: 'جاكيت تحت {value} °C',
            thickCoatBelowC: 'معطف سميك تحت {value} °C',
            hatGlovesAtOrBelowC: 'قبعة صوف وقفازات من {value} °C وأبرد',
            umbrella: 'اقتراح المظلة عند المطر والرياح الخفيفة',
            shortsFromC: 'السروال القصير ممكن من {value} °C إذا كان الجو جافًا',
            waterBottleFromC: 'قارورة ماء من {value} °C',
        },
        perChild: 'لكل طفل',
        coldDelta: {
            label: 'يبرد بسرعة',
            value: {
                zero: 'جاكيت أبكر بـ {count} درجة',
                one: 'جاكيت أبكر بدرجة واحدة',
                two: 'جاكيت أبكر بدرجتين',
                few: 'جاكيت أبكر بـ {count} درجات',
                many: 'جاكيت أبكر بـ {count} درجة',
                other: 'جاكيت أبكر بـ {count} درجة',
            },
            warmer: {
                zero: 'جاكيت لاحقًا بـ {count} درجة',
                one: 'جاكيت لاحقًا بدرجة واحدة',
                two: 'جاكيت لاحقًا بدرجتين',
                few: 'جاكيت لاحقًا بـ {count} درجات',
                many: 'جاكيت لاحقًا بـ {count} درجة',
                other: 'جاكيت لاحقًا بـ {count} درجة',
            },
            none: 'مثل الجميع',
            hint: 'هل يبرد طفل بسرعة؟ ارفع الرقم: فيحصل على الجاكيت أبكر بهذا العدد من الدرجات. أخفضه: لاحقًا.',
        },
        uvClearSky: 'قوة الشمس {value} (في سماء صافية)',
        uvCloud: 'قوة الشمس {value}',
        feelsLike: 'الإحساس {value} °C',
        wind: 'الرياح {bft} بوفورت',
        stale: 'الطقس غير معروف الآن',
        attribution: 'بيانات الطقس: MET Norway',
        feel: { cold: 'بارد', chilly: 'منعش', mild: 'لطيف', warm: 'دافئ', hot: 'حار' },
        itemLabels: {
            warning: 'انتبه',
            thunder: 'رعد',
            very_windy: 'رياح قوية',
            slippery: 'زلق',
            very_cold: 'بارد جدًا',
            thick_coat: 'معطف سميك',
            coat: 'جاكيت',
            sweater: 'سترة أو كنزة',
            raincoat: 'معطف مطر',
            boots: 'جزمة',
            hat_gloves: 'قبعة صوف وقفازات',
            no_umbrella: 'القلنسوة على الرأس',
            umbrella: 'مظلة',
            windy: 'رياح',
            shade: 'بعيدًا عن الشمس',
            sunscreen: 'كريم الشمس',
            sun_hat: 'قبعة الشمس',
            extra_drinks: 'اشرب كثيرًا',
            water_bottle: 'قارورة ماء',
            midday_shade: 'الظل',
            reapply: 'كريم الشمس مرة أخرى',
            shorts: 'سروال قصير',
        },
        itemWords: {
            warning: 'انتبه',
            thunder: 'ادخل إلى البيت إذا سمعت الرعد',
            very_windy: 'رياح قوية جدًا: أمسك الدراجة جيدًا',
            slippery: 'قد يكون الطريق زلقًا: امشِ وقُد الدراجة بهدوء',
            very_cold: 'بارد جدًا: وقت قصير في الخارج',
            thick_coat: 'معطف سميك',
            coat: 'جاكيت',
            sweater: 'سترة أو كنزة',
            raincoat: 'معطف مطر',
            boots: 'جزمة',
            hat_gloves: 'قبعة صوف وقفازات',
            no_umbrella: 'بلا مظلة، القلنسوة على الرأس',
            umbrella: 'مظلة',
            windy: 'رياح قوية: انتبه على الدراجة',
            shade: 'بعيدًا عن الشمس',
            sunscreen: 'كريم الشمس',
            sun_hat: 'قبعة الشمس',
            extra_drinks: 'اشرب أكثر والعب بهدوء في الظل',
            water_bottle: 'خذ قارورة ماء',
            midday_shade: 'العب في الظل بين 12 و3',
            reapply: 'كريم الشمس مرة أخرى الساعة 12',
            shorts: 'السروال القصير ممكن',
        },
        waterproof: 'معطف سميك مضاد للماء',
        headline: {
            rain: 'الساعة {time} تمطر: {items}.',
            wet: 'قد يكون الجو ممطرًا هذا الصباح: {items}.',
            wetLater: 'نحو الساعة {time} قد يكون الجو ممطرًا: {items}.',
            snow: 'الساعة {time} يتساقط الثلج: {items}.',
            thunder: 'الساعة {time} قد يأتي الرعد: ادخل إلى البيت إذا سمعته.',
            cold: 'بارد في الخارج الساعة {time}: {items}.',
            hot: 'سيصبح الجو حارًا: {items}.',
            coolThenWarm: 'منعش الساعة {time}، ودافئ لاحقًا: {items}.',
            sun: 'مشمس: {items}.',
            wind: 'رياح قوية الساعة {time}: انتبه على الدراجة.',
            nice: 'الساعة {time}: الجو {feel}.',
            niceWith: 'الساعة {time}: الجو {feel}، {items}.',
            warning: '{kids}',
            departure: 'الساعة {time} إلى {title}: {items}.',
        },
        and: 'و',
        warningKids: {
            wind: 'الرياح قوية جدًا. أغلق جاكيتك جيدًا وامشِ قريبًا من بابا أو ماما.',
            rain: 'سينزل مطر كثير جدًا. البس معطف المطر وخذ الجزمة.',
            thunder: 'قد يأتي الرعد. إذا سمعناه، ندخل إلى البيت.',
            snow: 'سيتساقط ثلج كثير. البس الجزمة وامشِ بهدوء.',
            ice: 'الطريق زلق في الخارج. امشِ بهدوء، ولا تركض.',
            heat: 'الجو حار جدًا. اشرب كثيرًا والعب في الظل.',
            cold: 'الجو بارد جدًا. البس ملابس دافئة: قبعة صوف وقفازات.',
            fog: 'يوجد ضباب. ابقَ قريبًا من بابا أو ماما.',
            other: 'انتبه جيدًا للطقس اليوم.',
        },
        warningLevel: { yellow: 'إنذار أصفر', orange: 'إنذار برتقالي', red: 'إنذار أحمر' },
        web: {
            todayTitle: 'طقس اليوم',
            todayTitleAt: 'طقس اليوم · {label}',
            tomorrowTitle: 'طقس الغد',
            tomorrowTitleAt: 'طقس الغد · {label}',
            nowLabel: 'الآن',
            tomorrowLabel: 'غدًا',
            invite: 'هل تريد نصائح الطقس على اللوحة؟',
            inviteBody: 'جاكيت أو جزمة أو كريم الشمس: نقولها في الأوقات التي يخرج فيها الأطفال من البيت.',
            notNow: 'ليس الآن',
            chooseLocation: 'اختيار الموقع',
            settings: 'الإعدادات',
            showOnKiosk: 'على اللوحة',
            save: 'حفظ',
            saved: 'تم الحفظ',
            resetDefaults: 'استعادة الإعدادات الأصلية',
            morningStart: 'الصباح من',
            morningEnd: 'الصباح حتى',
            alsoFor: '{name}: {items}',
            everyone: 'الجميع',
            tempNow: '{temp}°',
            staleBody: 'سنجلب الطقس من جديد في أقرب وقت.',
            childNone: 'لا أطفال في العائلة بعد.',
            offTitle: 'إيقاف الطقس؟',
            offConfirm: 'لا شيء آخر يستخدم الموقع. لذلك سنمسح أيضًا موقع عائلتكم وموقع الأجهزة اللوحية. هل تتابع؟',
            offConfirmButton: 'إيقاف ومسح الموقع',
            offNotice: 'الطقس مطفأ.',
            offNoLocation: 'الطقس مطفأ. اختر موقعًا؛ ثم شغّل الطقس هنا بضغطة واحدة.',
            turnOn: 'تشغيل الطقس',
            less: 'أقل',
            more: 'المزيد',
        },
        warningSource: {
            knmi: 'المصدر: KNMI',
            meteoalarm: 'المصدر: KNMI عبر MeteoAlarm',
            fake: 'المصدر: اختبار',
        },
        /** جملة الهطول فوق الرسم البياني. */
        precip: {
            dryAll: 'جاف خلال الساعات الـ{hours} القادمة.',
            nowUntil: '{kind} الآن، جاف عند {end}.',
            nowLong: '{kind} خلال الساعات القادمة.',
            fromUntil: '{kind} من {start}، جاف عند {end}.',
            dryUntil: 'جاف حتى {start}، ثم {kind}.',
            words: {
                drizzle: 'رذاذ',
                rain_light: 'مطر خفيف',
                rain: 'مطر',
                rain_heavy: 'مطر غزير',
                sleet: 'مطر مختلط بالثلج',
                snow: 'ثلج',
                hail: 'بَرَد',
                thunder: 'زخات رعدية',
            },
        },
    },
    prayer: {
        // Golf 4: Ramadan op het bord (DESIGN §8.GB.14).
        ramadan: prayerRamadanAr,
        title: 'مواقيت الصلاة',
        settingsBody: 'الأوقات لمنطقتكم، على اللوحة في غرفة الجلوس',
        enabled: 'استخدام مواقيت الصلاة',
        needsLocation: 'اختر موقعًا أولًا. ثم نحسب الأوقات لمنطقتكم.',
        privacy: 'هذا جزء من «ما يناسب عائلتنا». الوالدان فقط يريان الإعدادات؛ الأقارب المربوطون والضيوف لا يرونها أبدًا.',
        boardVisible: 'انتبه: الأوقات والبطاقة تظهر على اللوحة، فيراها كل من في الغرفة (والزوار أو الجليسة أيضًا).',
        call: { turkish: 'الأذان', arabic: 'الأذان' },
        callTitle: { turkish: 'الأذان', arabic: 'الأذان' },
        setup: {
            quickTitle: 'مواقيت الصلاة',
            quickBody: 'نحسب وفق {method}. هل يوافق هذا مسجدكم؟ إذن انتهيت. يمكنك دائمًا ضبط الأوقات والصوت لكل صلاة لاحقًا.',
            quickNoCall: 'لا يوجد بعد تسجيل {call}. حتى ترفعوا تسجيلًا بأنفسكم، يُسمع على الجهاز اللوحي في غرفة الجلوس جرس خفيف.',
            quickTone: 'في «أي تسجيل؟» اختير الآن الجرس الخفيف. هل تريد سماع {call}؟ اختر هناك التسجيل المرفق عبر «مزيد من الإعدادات».',
            quickTimes: 'اليوم في {place}',
            quickDone: 'تم',
            quickMore: 'مزيد من الإعدادات',
            step1: 'كيف نحسب الأوقات؟',
            step1Body: 'لا تحسب كل المساجد بالطريقة نفسها. اختر ما يستخدمه مسجدكم، أو اترك اختيارنا.',
            step2: 'طابِق الأوقات مع مسجدك',
            step2Body: 'ضع جدول مسجدك بجانبها. إذا اختلف وقت، فحرّكه. في الصيف تختلف المساجد أحيانًا بنصف ساعة أو أكثر: اضبط عندها لكل شهر، أو أدخل الجدول السنوي.',
            step3: 'ماذا يُسمع على الجهاز اللوحي؟',
            step3Body: 'يُسمع {call} على الجهاز اللوحي في غرفة الجلوس. تبقى الأجهزة الأخرى صامتة، إلا إذا شغّلتها.',
            step3BodyNoCall: 'لا يوجد بعد تسجيل {call}. حتى ترفعوا تسجيلًا أدناه، يُسمع عند «{callTitle}» الجرس الخفيف. تبقى الأجهزة الأخرى صامتة، إلا إذا شغّلتها.',
            step3BodyTone: 'عند «{callTitle}» يُسمع الآن الجرس الخفيف، لأنه مختار في «{step4}». تبقى الأجهزة الأخرى صامتة، إلا إذا شغّلتها.',
            step4: 'أي تسجيل؟',
            done: 'تم. الصلاة القادمة تظهر الآن على اللوحة.',
        },
        method: {
            diyanet: 'ديانت (تركيا)',
            mwl: 'رابطة العالم الإسلامي',
            uoif: 'UOIF (فرنسا)',
            morocco: 'المغرب',
            jafari: 'الجعفري (شيعي)',
            eu_joint: 'التقويم الأوروبي المشترك (ديانت · ملّي غوروش)',
        },
        methodInSentence: {
            diyanet: 'تقويم ديانت (تركيا)',
            mwl: 'رابطة العالم الإسلامي',
            uoif: 'UOIF (فرنسا)',
            morocco: 'الطريقة المغربية',
            jafari: 'الطريقة الجعفرية (شيعي)',
            eu_joint: 'التقويم الأوروبي المشترك (ديانت · ملّي غوروش)',
        },
        methodHint: {
            diyanet: 'تقويم تركيا. المساجد التركية في أوروبا تستخدم التقويم الأوروبي أعلاه.',
            mwl: 'منتشرة في أوروبا. اختيار جيد إذا لم تكن تعرف.',
            uoif: 'فجر متأخر وعشاء أبكر (12°).',
            morocco: 'ما تستخدمه المساجد المغربية غالبًا.',
            jafari: 'المغرب بعد زوال الحمرة، نحو ربع ساعة بعد غروب الشمس.',
            eu_joint: 'منذ 2023 تقويم واحد لديانت (ISN، DITIB) وملّي غوروش في أوروبا. اختره إن كان مسجدكم تركيًا.',
        },
        asrSchool: {
            standard: 'المعتاد (الوقت الأول)',
            hanafi: 'الحنفي (متأخر بعد الظهر)',
        },
        asrSource: {
            title: 'وقت {asr}',
            madhab: 'حسب مذهبكم',
            manual: 'ضبطتموه بأنفسكم',
            unset: 'الافتراضي',
            follow: 'اتّباع المذهب مرة أخرى',
            madhabLink: 'اختيار المذهب أو تغييره',
            why: {
                hanafi: 'تتبعون المذهب الحنفي: {asr} متأخر بعد الظهر.',
                other_madhab: 'تتبعون المذهب {madhab}: {asr} في الوقت المعتاد.',
                calendar: 'تتبعون المذهب الحنفي. تقويم ديانت وملّي غوروش يذكر لـ{asr} الوقت الأول (العصر الأول)، مثل مسجدكم. تفضّلون الوقت المتأخر (العصر الثاني)؟ اختاروا «{hanafi}» في الأعلى.',
                no_madhab: 'لم يُختر مذهب بعد: {asr} في الوقت المعتاد.',
            },
            manualWhy: 'اخترتم هذا بأنفسكم. تغيير المذهب لا يغيّره.',
        },
        madhabSuggestion: {
            body: 'تتبعون المذهب الحنفي. المساجد التركية في أوروبا تحسب وفق {method}.',
            apply: 'استخدام هذا التقويم',
            applied: 'نحسب الآن وفق {method}.',
        },
        naming: { turkish: 'الأسماء التركية', arabic: 'الأسماء العربية' },
        namingTitle: 'أسماء الصلوات',
        names: {
            turkish: {
                fajr: 'Sabah',
                sunrise: 'Güneş',
                dhuhr: 'Öğle',
                asr: 'İkindi',
                maghrib: 'Akşam',
                isha: 'Yatsı',
            },
            arabic: {
                fajr: 'الفجر',
                sunrise: 'الشروق',
                dhuhr: 'الظهر',
                asr: 'العصر',
                maghrib: 'المغرب',
                isha: 'العشاء',
            },
        },
        cardNames: {
            turkish: { fajr: 'Sabah', dhuhr: 'Öğle', asr: 'İkindi', maghrib: 'Akşam', isha: 'Yatsı' },
            arabic: { fajr: 'الفجر', dhuhr: 'الظهر', asr: 'العصر', maghrib: 'المغرب', isha: 'العشاء' },
        },
        sunriseNote: 'الشروق نهاية وقت {fajr}. لا يُسمع عنده أي صوت.',
        offsets: {
            title: 'الفرق لكل صلاة',
            sameAllYear: 'نفسه طوال السنة',
            perMonth: 'لكل شهر',
            month: 'في {month}',
            later: 'بعد {value} د',
            earlier: 'قبل {value} د',
            seeded: 'مضبوطة على جدول ديانت لروتردام، ومراجعة لشهر سبتمبر فقط. تحقّق منها مع مسجدك، خاصة في الصيف.',
            tableDay: 'هذه الأوقات من جدول مسجدك. الفروق تسري فقط على الأيام غير الموجودة في الجدول.',
            compare: 'قارن مع جدول مسجدك',
            dstCheck: 'تغيّرت الساعة. هل ما زالت الأوقات توافق جدول مسجدكم؟',
            dstYes: 'نعم، صحيح',
            dstAdjust: 'تعديل',
        },
        table: {
            title: 'إدخال جدول مسجدك',
            body: 'الصق الجدول السنوي (في كل سطر: التاريخ;{fajr};الشروق;{dhuhr};{asr};{maghrib};{isha}). يوم من الجدول يحل محل حسابنا.',
            read: 'إدخال',
            result: {
                zero: 'لم يُدخل أي يوم',
                one: 'أُدخل يوم واحد',
                two: 'أُدخل يومان',
                few: 'أُدخلت {count} أيام',
                many: 'أُدخل {count} يومًا',
                other: 'أُدخل {count} يوم',
            },
            badLines: 'تعذرت قراءة: السطر {lines}',
            fromTable: 'من جدول مسجدك',
            remove: 'إزالة الجدول',
        },
        sound: {
            adhan: '{callTitle}',
            adhanPending: '{callTitle} (لا تسجيل بعد: الجرس الآن)',
            adhanTone: '{callTitle} (الجرس الآن، انظر «{step4}»)',
            chime: 'جرس خفيف',
            silent: 'صامت (البطاقة فقط)',
        },
        yearRange: '{name}: في {month} نحو {time}',
        fajrWarning: '{fajr} قبل الشروق. عندها يوقظ {call} البيت كله.',
        fajrNeedsRecording: 'لصلاة {fajr} أذان خاص (فيه «الصلاة خير من النوم»)، لذلك لا يُسمع عندها الأذان العادي أبدًا. ارفع تسجيلًا خاصًا لصلاة {fajr}، أو اختر الجرس.',
        quiet: {
            title: 'بعد المساء وفي الليل',
            body: 'بعد {from} وحتى {until} يُسمع بدلًا من {call}:',
            chime: 'جرس خفيف',
            silent: 'لا شيء (البطاقة فقط في غرفة الجلوس)',
            adhan: '{call} رغم ذلك',
            hint: 'في يونيو يكون {isha} نحو منتصف الليل و{maghrib} بعد العاشرة. مع الجرس يبقى البيت هادئًا.',
        },
        /** Eenmalige melding na het overzetten naar de gezamenlijke kalender (0041). */
        methodNotice: 'مواقيت الصلاة تتبع الآن التقويم الأوروبي لديانت وملّي غوروش؛ لذلك يختلف وقتا {fajr} و{isha} في الصيف.',
        methodNoticeOk: 'حسنًا',
        /** Eerlijk over eu_joint (gefit op de Diyanet-tabellen, niet officieel; review g6b fs r1). */
        methodApprox: 'نحسب التقويم المشترك بأنفسنا. في روتردام وأمستردام يطابق الجدول المنشور بفارق دقيقة أو دقيقتين طوال السنة. ولا يتقدم أي وقت صلاة ولا أي أذان على الجهاز اللوحي على جدول ديانت: نقرّب الأوقات إلى الأعلى، ونضيف إلى {fajr} دقيقتين، و10 دقائق من منتصف أبريل إلى منتصف سبتمبر. أما الإمساك، بداية الصيام، فلا يتأخر أبدًا عن الجدول؛ وفي رمضان تظهر على اللوحة أوقات الإمساك و{fajr} معًا. في أماكن أخرى، وخاصة من منتصف أبريل إلى منتصف سبتمبر، قد يختلف مسجدكم ببضع دقائق (حتى 9 دقائق تقريبًا). اضبطه على مسجدكم، مثلًا بإضافة بضع دقائق إلى {fajr} في «الفرق لكل صلاة»، أو استورد جدول مسجدكم.',
        /** Korte zin bij de tijden (Vandaag, tablet) in de zomerweken van eu_joint. */
        methodTune: 'مواقيت الصيف: قد يختلف مسجدكم ببضع دقائق. اضبطها على مسجدكم.',
        /** Opnamebibliotheek (golf 6b, DESIGN §8.GB.15). */
        library: {
            intro: 'اختر تسجيلًا حسب المنطقة. استمع أولًا: هذه تسجيلات حقيقية، أحيانًا مع أصوات المدينة أو الطيور.',
            regions: {
                arabic: 'الأسلوب العربي',
                hijaz: 'مكة (الحجاز)',
                turkish: 'إسطنبول وتركيا',
                maghreb: 'المغرب',
                egypt: 'مصر',
                levant: 'الأردن',
                southeast_asia: 'ماليزيا',
                central_asia: 'كازاخستان',
                europe: 'أوروبا',
                other: 'أخرى (المكان غير معروف)',
            },
            places: {
                mecca: 'مكة، المسجد الحرام',
                istanbul: 'إسطنبول (قصير)',
                istanbul_fatih: 'إسطنبول، جامع قلندرخانه',
                mardin: 'ماردين، الصباح',
                patara: 'باتارا، قرية، الصباح',
                casablanca: 'الدار البيضاء، مسجد الحسن الثاني',
                marrakech: 'مراكش، جامع الفنا',
                marrakech_medina: 'مراكش، المدينة القديمة، الصباح',
                quseir: 'القصير، على البحر',
                amman: 'عمّان، الصباح',
                kuala_lumpur: 'كوالالمبور، الصباح',
                shalqar: 'شالقار',
                malmo: 'مالمو، الصباح',
                indoor: 'الجمعة، مسجّل في الداخل',
            },
            option: '{place} ({year})',
            meta: '{author} · {license} · {duration}',
            fajrTitle: 'تسجيل لـ{fajr}',
            fajrBody: 'لـ{fajr} أذان خاص فيه "الصلاة خير من النوم". اختر تسجيلًا صباحيًا أو ارفع تسجيلك؛ وإلا يرن الجرس عند {fajr}.',
            fajrNone: 'لا شيء (الجرس)',
            fajrUnverified: 'تسجيل صباحي، لم يُتحقق بعد من جملة الصباح',
            sources: 'المصادر والتراخيص',
            sourcesIntro: 'كل التسجيلات حرة الاستخدام. لكل تسجيل العنوان والمسجِّل والمصدر والترخيص. أزلنا الصمت في البداية والنهاية، وسوّينا الصوت، وحوّلناها إلى AAC.',
            by: '"{title}" من {author}، عبر {platform}',
            shareAlike: 'نسختنا المعدّلة مرخّصة أيضًا بـ{license}.',
            report: 'هل المصدر خاطئ؟ راسلنا على support@amumin.com وسنزيل التسجيل.',
        },
        audio: {
            builtin_a: '{callTitle}، بالأسلوب العربي',
            builtin_b: '{callTitle}، بالأسلوب العربي (أقصر)',
            sunniNote: 'هذه التسجيلات بالنص السنّي.',
            shiaNote: 'تسجيلاتنا بالنص السنّي. اختر الجرس أو تسجيلًا خاصًا.',
            tone: 'جرس خفيف (صوت خاص، مختلف عن أجراس المهام)',
            own: 'رفع تسجيل خاص (m4a أو mp3، 5 دقائق على الأكثر)',
            ownFajr: 'تسجيل خاص لصلاة {fajr}',
            credits: 'عن التسجيلات',
        },
        kidsMayStop: 'يمكن للأطفال إيقاف {call}',
        kidsMayStopHint: 'عند الإطفاء: زر الإيقاف في تحكم الوالدين.',
        device: {
            title: 'على أي أجهزة لوحية؟',
            sound: 'تشغيل {callTitle}',
            soundAny: 'صوت عند الصلاة',
            line: 'الصلاة القادمة في الأعلى',
            card: 'بطاقة عند الصلاة',
            cardNight: 'في الغرف لا تظهر بطاقة ليلًا أبدًا.',
            volume: 'مستوى الصوت',
            volumeIos: 'على iPad تضبط الصوت بالأزرار الجانبية.',
            test: 'اختبار على الجهاز اللوحي',
            locked: '{name}: الصوت مطفأ. اضغط مرة واحدة على شاشة ذلك الجهاز.',
            unsupported: '{name}: هذا الجهاز لا يستطيع تشغيل الصوت.',
            outcome: {
                played: 'سُمع الساعة {time}',
                card_locked: 'صامت الساعة {time}: الصوت كان مطفأ',
                card_late: 'صامت الساعة {time}: شوهد متأخرًا',
                load_failed: 'صامت الساعة {time}: لم يُحمّل التسجيل',
                skipped: 'تُخطّي الساعة {time}',
            },
            checklist: 'اترك الشاشة مضاءة (القفل التلقائي: أبدًا). في «الوصول الموجّه»: زر التشغيل مطفأ، وأزرار الصوت مفعّلة. لا تُنِم الـ iPad بزر التشغيل: وإلا يبقى {isha} و{fajr} صامتين.',
        },
        kiosk: {
            next: '{name} {time}',
            nextIn: '{name} {time} · بعد {left}',
            inMinutes: 'بعد {n} د',
            inHours: 'بعد {n} س',
            now: 'الآن: {name}',
            cardTitle: 'حان وقت صلاة {name}',
            playing: '{callTitle} يُرفع الآن',
            playingChime: 'الجرس يرن',
            cardStop: 'إيقاف',
            cardStopHold: 'اضغط باستمرار للإيقاف',
            cardClose: 'إغلاق',
            soundLocked: 'اضغط للصوت',
            soundLockedLong: 'الصوت مطفأ. اضغط لتشغيله.',
            unsupported: 'هذا الجهاز لا يستطيع تشغيل الصوت',
            unknown: 'مواقيت الصلاة غير معروفة الآن',
        },
        question: {
            title: 'مواقيت الصلاة على اللوحة؟',
            body: 'عندها تظهر الصلاة القادمة في أعلى اللوحة، ويُرفع {call} في أوقات الصلاة على الجهاز اللوحي في غرفة الجلوس.',
            body2: '{fajr} صامت في الأصل. يمكنك تعديل كل شيء لاحقًا.',
            yes: 'نعم، من فضلك',
            no: 'لا، ليس الآن',
            declined: 'يمكنك التشغيل لاحقًا في الإعدادات > مواقيت الصلاة.',
            placeTitle: 'أين تسكنون؟',
            placeBody: 'عندها نحسب الأوقات لمنطقتكم. يكفي رمز بريدي أو مدينة؛ نحفظ فقط منطقة بحجم كيلومتر تقريبًا.',
            placeOther: 'خارج هولندا، أو جهاز لوحي في مكان آخر؟ اضبط ذلك في الإعدادات > الموقع.',
            placeSave: 'استخدم هذا المكان',
            placeChosen: 'الأوقات لـ {label}',
            /** Golf 6c: waarom deze methode (de mazhab, nooit de keuken). */
            methodMadhab: 'نحسب وفق {method}، لأنكم تتبعون المذهب الحنفي.',
            methodDefault: 'نحسب وفق {method}.',
            change: 'تغيير',
            methodChoose: 'طريقة الحساب',
            becauseOne: 'لأن دين {name} الإسلام.',
            becauseMany: 'لأن دين {names} الإسلام.',
            next: 'متابعة',
            done: 'تم',
            enabled: 'الصلاة القادمة تظهر الآن على اللوحة.',
            renew: 'الموافقة والتشغيل',
            off: 'مواقيت الصلاة مطفأة. لا تعرضها اللوحة ولا يُسمع شيء.',
            turnOn: 'تشغيل مواقيت الصلاة',
            offBody: 'تفضّل التوقف قليلًا؟ عندها تختفي الأوقات من اللوحة ولا يُسمع شيء. تبقى اختياراتك للطريقة والصوت محفوظة؛ وإذا كان الطقس مطفأ أيضًا، نمسح الموقع.',
            turnOff: 'إيقاف مواقيت الصلاة',
            turnOffConfirm: 'إيقاف مواقيت الصلاة؟ يمكنك تشغيلها هنا دائمًا من جديد.',
            turnOffYes: 'نعم، أوقفها',
            turnOffCancel: 'لا، تراجعت',
            renewOnly: 'إعطاء الموافقة',
            renewBody: 'تغيّر الشرح في «ما يناسب عائلتنا»: أصبح يذكر أيضًا أقسامًا إضافية على اللوحة، مثل مواقيت الصلاة هذه. أعطِ موافقتك هنا من جديد لتستمر في استخدامها.',
        },
        web: {
            consentRenewal: 'تغيّر الشرح في «ما يناسب عائلتنا»: أصبح يذكر أيضًا أقسامًا إضافية على اللوحة، مثل مواقيت الصلاة هذه. أعطِ موافقتك هناك من جديد أولًا.',
            consentLink: 'إلى ما يناسب عائلتنا',
            locationLink: 'اختيار الموقع',
            save: 'حفظ',
            saved: 'تم الحفظ',
            today: 'اليوم، {place}',
            ourTime: 'محسوب',
            offset: 'الفرق',
            month: 'الشهر',
            tableDays: {
                zero: 'لا أيام من جدول مسجدك',
                one: 'يوم واحد من جدول مسجدك',
                two: 'يومان من جدول مسجدك',
                few: '{count} أيام من جدول مسجدك',
                many: '{count} يومًا من جدول مسجدك',
                other: '{count} يوم من جدول مسجدك',
            },
            tablePlaceholder: '2026-10-01;05:40;07:30;13:35;16:45;19:15;20:50',
            listen: 'استمع',
            /** Tijdens het afspelen (review g6b ux r1: een stopknop, geen luidspreker met streep). */
            listenStop: 'إيقاف',
            listenPlaying: 'قيد التشغيل',
            upload: 'اختيار ملف',
            uploaded: 'التسجيل الخاص مستخدم',
            uploadFailed: 'فقط ملف m4a أو mp3 لا يزيد عن 5 دقائق و5 MB.',
            last: 'آخر مرة: {items}',
            testPending: 'أُرسل الاختبار. تظهر النتيجة هنا خلال دقيقة.',
            uploadCall: 'رفع تسجيل خاص: {call}',
            testResult: {
                played: 'سُمع',
                card_locked: 'صامت: الصوت كان مطفأ',
                load_failed: 'صامت: لم يُحمّل التسجيل',
                skipped: 'تُخطّي',
            },
            volume: 'مستوى الصوت (Android، Fully Kiosk)',
            noTablets: 'لا جهاز لوحي مربوط بعد.',
            credits: {
                builtin: '{callTitle}، بالأسلوب العربي: «{title}» من {author}، على',
                license: 'CC0 1.0 (ملكية عامة)',
                processing: 'حوّلنا التسجيل إلى AAC وMP3 (أحادي) وجعلنا صوته بمستوى الجرس. ولم نغيّر فيه شيئًا آخر.',
                tone: 'الجرس الخفيف صوت خاص من AMUMIN.',
            },
        },
        attribution: 'مواقيت الصلاة: حساب خاص · طريقة {method}',
        attributionTable: 'مواقيت الصلاة: جدول مسجدك',
        hijri: {
            months: [
                'محرم',
                'صفر',
                'ربيع الأول',
                'ربيع الآخر',
                'جمادى الأولى',
                'جمادى الآخرة',
                'رجب',
                'شعبان',
                'رمضان',
                'شوال',
                'ذو القعدة',
                'ذو الحجة',
            ],
            pattern: '{day} {month} {year} هـ',
        },
    },
};
//# sourceMappingURL=weatherPrayer.ar.js.map